import React from "react";
import FormInput from "../../../../../components/Universal/FormInput.component";
import DropDownInput from "../../../../../components/Universal/DropDownInput.component";
import { Formik } from "formik";

const Body = () => {
  const advertisementTypes = ["Online Ads", "Outdoor Ads", "Print Ads"];
  const paymentModes = ["Cash", "Bank Transfer", "UPI", "Cheque"];
  const verifiers = ["Manager A", "Manager B", "Auditor X"];

  return (
    <Formik
      initialValues={{
        advertisementType: "",
        platformName: "",
        b2bPartner: "",
        contact: "",
        duration: "",
        description: "",
        totalAmount: "",
        paidAmount: "",
        paymentMode: "",
        verifier: "",
        gst: "",
      }}
      onSubmit={(values) => {
        console.log("Submitted:", values);
      }}
    >
      {({
        values,
        setFieldValue,
        handleSubmit,
        touched,
        errors,
        setTouched,
      }) => (
        <form onSubmit={handleSubmit} className="p-1">
          <div className="grid grid-cols-2 gap-4 mb-05">
            {/* Advertisement Type */}
            <DropDownInput
              name="advertisementType"
              label="Advertisement type"
              value={values.advertisementType}
              placeholder="Choose a type"
              suggestionList={advertisementTypes}
              setFieldValue={(val) => {
                setFieldValue("advertisementType", val);

                // Auto-fill platform name if "Outdoor Ads" is selected
                if (val === "Outdoor Ads") {
                  setFieldValue("platformName", "Outdoor");
                } else {
                  setFieldValue("platformName", "");
                }
              }}
            />

            {/* Platform Name */}
            <FormInput
              name="platformName"
              label="Platform name"
              type="text"
              placeholder="Enter platform name"
              value={values.platformName}
              touched={touched}
              errors={errors}
              setFieldValue={(e) =>
                setFieldValue("platformName", e.target.value)
              }
            />

            {/* B2B Partner */}
            <FormInput
              name="b2bPartner"
              label="B2B partner/provider (if any)"
              type="text"
              placeholder="Enter name of partner"
              touched={touched}
              errors={errors}
              setFieldValue={(e) => setFieldValue("b2bPartner", e.target.value)}
            />

            {/* Contact */}
            <FormInput
              name="contact"
              label="Contact (if any)"
              type="text"
              placeholder="Enter phone number"
              touched={touched}
              errors={errors}
              setFieldValue={(e) => setFieldValue("contact", e.target.value)}
            />

            {/* Duration */}
            <FormInput
              name="duration"
              label="Duration"
              type="number"
              placeholder="Enter duration in days"
              touched={touched}
              errors={errors}
              setFieldValue={(e) => setFieldValue("duration", e.target.value)}
            />

            {/* Description */}
            <FormInput
              name="description"
              label="Description"
              type="text"
              placeholder="Type something here"
              touched={touched}
              errors={errors}
              setFieldValue={(e) =>
                setFieldValue("description", e.target.value)
              }
            />

            {/* Total Amount */}
            <FormInput
              name="totalAmount"
              label="Total amount (INR)"
              type="number"
              placeholder="Enter amount"
              touched={touched}
              errors={errors}
              setFieldValue={(e) =>
                setFieldValue("totalAmount", e.target.value)
              }
            />

            {/* Paid Amount */}
            <FormInput
              name="paidAmount"
              label="Paid amount (INR)"
              type="number"
              placeholder="Enter paid amount"
              touched={touched}
              errors={errors}
              setFieldValue={(e) => setFieldValue("paidAmount", e.target.value)}
            />

            {/* Payment Mode */}
            <DropDownInput
              name="paymentMode"
              label="Payment mode"
              value={values.paymentMode}
              placeholder="Choose payment mode"
              suggestionList={paymentModes}
              setFieldValue={(val) => setFieldValue("paymentMode", val)}
            />

            {/* Verifier */}
            <DropDownInput
              name="verifier"
              label="Verifier"
              value={values.verifier}
              placeholder="Choose payment verifier"
              suggestionList={verifiers}
              setFieldValue={(val) => setFieldValue("verifier", val)}
            />

            {/* GST */}
            <FormInput
              name="gst"
              label="GST (if any)"
              type="number"
              placeholder="Enter GST in %"
              touched={touched}
              errors={errors}
              setFieldValue={(e) => setFieldValue("gst", e.target.value)}
            />
          </div>

          <button type="submit" className="actionBtn w-full mt-1">
            Collect
          </button>
        </form>
      )}
    </Formik>
  );
};

export default Body;
